module.exports = __webpack_public_path__ + "3debd902ea2c94cf548cc2e1720d816e.png";